import { useCallback } from "react";
const useHasRole = (currentUser) => {
  return useCallback(
    (rolesToCheck) => {
      if (currentUser?.roles) {
        if (typeof rolesToCheck === "string") {
          if (typeof currentUser.roles === "string") {
            return currentUser.roles === rolesToCheck;
          } else if (Array.isArray(currentUser.roles)) {
            return currentUser.roles?.some(
              (allowedRole) => rolesToCheck === allowedRole
            );
          }
        }
        if (Array.isArray(rolesToCheck)) {
          if (Array.isArray(currentUser.roles)) {
            return currentUser.roles?.some(
              (allowedRole) => rolesToCheck.includes(allowedRole)
            );
          } else if (typeof currentUser.roles === "string") {
            return rolesToCheck.some(
              (allowedRole) => currentUser?.roles === allowedRole
            );
          }
        }
      }
      return false;
    },
    [currentUser]
  );
};
export {
  useHasRole
};
